import AccountRoutes from "Application/Account/Constants/AccountRoutes";
import HomeRoutes from "Application/Home/Constants/HomeRoutes";
import NotificationRoutes from "Application/Notification/Constants/NotificationRoutes";
import VisitsRoutes from "Application/Visits/Constants/VisitsRoutes";

const AppRoutes = [
    AccountRoutes,
    HomeRoutes,
    VisitsRoutes,
    NotificationRoutes
]

export { AppRoutes }